"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _authRequest = _interopRequireDefault(require("./auth-request"));

var _tokenManager = _interopRequireDefault(require("./token-manager"));

var _StorageInterface = _interopRequireDefault(require("./Storage/Domain/StorageInterface"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const GeckoAuthSDK = ({
  baseUrl,
  storage
}) => {
  if (!baseUrl || typeof baseUrl !== 'string') {
    throw new Error('GeckoAuth base url not provided');
  }
  /*
  |--------------------------------------------------------------------------
  | Storage Interface
  |--------------------------------------------------------------------------
  | Storage service must match interface
  |
  | @throws InvalidStorageProvider - if expected methods are not defined
  | 
  */


  (0, _StorageInterface.default)(storage);
  const AuthRequestInstance = (0, _authRequest.default)(baseUrl);
  const TokenManagerInstance = (0, _tokenManager.default)(AuthRequestInstance, storage);
  return {
    AuthRequest: AuthRequestInstance,
    TokenManager: TokenManagerInstance
  };
};

var _default = GeckoAuthSDK;
exports.default = _default;